export function getStatsUserActivityRoutes() {
  return [
    {
      path: "/superadmin/user-activity",
      name: "stats-user-activity",
      component: () => import("./components/StatsUserActivityOld.vue"),
    },
  ]
}
